/**
 * Created by jiayanfeng on 2018/3/19.
 * 控制台页面的Redux相关
 */

import {combineReducers} from "redux";
import axios from "axios";
//region Constants
export const Console_Page_Menu = "Console_Page/Menu";
export const Console_Page_Switcher_Enabled_Change = "Console_Page/Switcher_Enabled_Change";
export const Console_Page_Content_Height = "Console_Page/Console_Page_Content_Height";
export const Console_Page_Content_Key = "Console_Page/Console_Page_Content_Key";
export const Console_Page_Content_Console_Key = "Console_Page/Console_Page_Content_Console_Key";
export const Console_Page_Content_EULayout = "Console_Page/Console_Page_Content_EULayout";
export const Console_Page_Content_EULFlag = "Console_Page/Console_Page_Content_EULFlag";
//endregion

//region Actions
function getMenuDone(menu) {
  return {
    type: Console_Page_Menu,
    data: menu
  };
}
// export const getMenuAction =()=>(dispatch,getState) => {
//   const state = getState();
//   return axios({
//     method: "post",
//     url: `/query-menu?enterpriseId=${state.userData.enterprises[state.userData.currentEnterprise].id}&roleId=${state.userData.roles[state.userData.currentRole].id}&userId=${state.authentication.userId}`,
//     contentType: "application/json",
//     withCredentials: true
//   }).then(
//     response => response.data
//   ).then(
//     menu => {
//       dispatch(getMenuDone(
//         menu
//       ));
//     }
//   );
// };

//update by handd 2020-03-25 切换至菜单微服务接口
export const getMenuAction = () => (dispatch, getState) => {
  const state = getState();
  let enterpriseId = state.userData ? state ?.userData.enterprises[state.userData.currentEnterprise] ?.id:
    state.userData.enterprises[state.userData.currentEnterprise].id;
  let roleId = state.userData ? state ?.userData.roles[state.userData.currentRole] ?.id:
    state.userData.roles[state.userData.currentRole].id;

  // console.info("roleIds", roleIds);
  return axios({
    method: "get",
    url: `/api-menu/query-menu?userId=${state.authentication.userId}${!!enterpriseId?`&enterpriseId=${enterpriseId}&roleId=${roleId}`:""}`,
    contentType: "application/json",
    withCredentials: true
  }).then(
    response => response.data
  ).then(
    menu => {
      console.log("menu", menu);
      dispatch(getMenuDone(
        menu
      ));
    }
  );
};

//endregion

export function changeSwitcherEnabledAction(flag) {
  return {
    type: Console_Page_Switcher_Enabled_Change,
    data: flag
  }
}

//region Reducers

function menu(state = [], action) {
  switch (action.type) {
    case Console_Page_Menu:
      return action.data;
    default:
      return state;
  }
}

function isSwitcherEnabled(state = true, action) {
  switch (action.type) {
    case Console_Page_Switcher_Enabled_Change:
      return action.data;
    default:
      return state;
  }
}

export const setContentHeight = (data) => {
  return {
    type: Console_Page_Content_Height,
    data: data
  }
};

export const setKey = (data) => {
  return {
    type: Console_Page_Content_Key,
    data: data
  }
};
export const setConsoleKey = (data) => {
  return {
    type: Console_Page_Content_Console_Key,
    data: data
  }
};
export const setEULayout = (data) => {
  return {
    type: Console_Page_Content_EULayout,
    data: data
  }
};

export const setEULFlag = (data) => {
  return {
    type: Console_Page_Content_EULFlag,
    data: data
  }
};


function contentInfo(state = {
  newActiveKey: 0,
  contentHeight: 0,
  keyFlag:false,
  flag:true,
  EULFlag:true,
  EULayout: [
    { i: 'g', x: 0, y: 15, w: 12, h: 12,minW: 5,minH:12},
    { i: 'a', x: 0, y: 8, w: 12, h: 7 ,minW: 4,minH:7},
    { i: 'b', x: 0, y: 0, w: 12, h: 8,minW: 4,minH:8},
    { i: 'c', x: 0, y: 27, w: 12, h: 11,minW: 2,minH:11},
    { i: 'd', x: 0, y: 50, w: 12, h: 10,minW: 2,minH:10 },
    { i: 'e', x: 0, y: 60, w: 12, h: 11 ,minW: 3,minH:11},
    { i: 'f', x: 0, y: 71, w: 12, h: 10,minW: 4,minH:10 },
    { i: 'h', x: 0, y: 81, w: 12, h: 11,minW: 5,minH:11 },
    { i: 'i', x: 0, y: 92, w: 12, h: 11,minW: 5,minH:11 },
    { i: 'j', x: 0, y: 38, w: 12, h: 12,minW: 5,minH:12 },
    { i: 'k', x: 0, y: 103, w: 12, h: 11,minW: 4,minH:11 },
    { i: 'l', x: 0, y: 114, w: 12, h: 11,minW: 4,minH:11 },
    { i: 'm', x: 0, y: 124, w: 12, h: 10,minW: 4,minH:10 },
    { i: 'n', x: 0, y: 134, w: 12, h: 11,minW: 4,minH:11 },
    { i: 'o', x: 0, y: 145, w: 12, h: 9,minW: 4,minH:9 },
    { i: 'p', x: 0, y: 154, w: 12, h: 24,minW: 7,minH:24 },
    { i: 'q', x: 0, y: 178, w: 12, h: 24,minW: 7,minH:24 }
  ]
}, action) {
  switch (action.type) {
    case Console_Page_Content_Height:
      return {...state,
        contentHeight: action.data
      };
      case Console_Page_Content_Key:
      return {
        ...state,
        keyFlag: action.data
      };
      case Console_Page_Content_Console_Key:
      return {
        ...state,
        newActiveKey: action.data
      };
      case Console_Page_Content_EULayout:
      return {
        ...state,
        EULayout: action.data
      };
      case Console_Page_Content_EULFlag:
      return {
        ...state,
        EULFlag: action.data
      };
    default:
      return state
  }
}


const consoleReducer = combineReducers({menu, isSwitcherEnabled, contentInfo});
export default consoleReducer;

//endregion
